$(document).ready(function(){
    // Initial click to open the search input and toggle to cancel icon
    $(document).on('click', '#Search_Icon', function() {
        $('.search__input__wrapper').slideToggle();
        // Change to Cancel icon
        $('#icon-wrapper').html(`
            <svg id="Cancel_Icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#4C303F" d="m12 12.708l-5.246 5.246q-.14.14-.344.15t-.364-.15t-.16-.354t.16-.354L11.292 12L6.046 6.754q-.14-.14-.15-.344t.15-.364t.354-.16t.354.16L12 11.292l5.246-5.246q.14-.14.345-.15q.203-.01.363.15t.16.354t-.16.354L12.708 12l5.246 5.246q.14.14.15.345q.01.203-.15.363t-.354.16t-.354-.16z"/></svg>
        `);
    });

    // When the cancel icon is clicked, close the input and revert to search icon
    $(document).on('click', '#Cancel_Icon', function() {
        $('.search__input__wrapper').slideToggle();
        // Change back to Search icon
        $('#icon-wrapper').html(`
            <svg id="Search_Icon" data-name="Search Icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17.336" height="16.683" viewBox="0 0 17.336 16.683">
                <defs>
                  <clipPath id="clip-path">
                    <rect id="Rettangolo_299" data-name="Rettangolo 299" width="17.336" height="16.683" fill="#4c303f"/>
                  </clipPath>
                </defs>
                <g id="Raggruppa_370" data-name="Raggruppa 370" transform="translate(0 0)" clip-path="url(#clip-path)">
                  <path id="Tracciato_154" data-name="Tracciato 154" d="M10.192,0A7.131,7.131,0,0,0,4.442,11.365L0,15.806l.876.876L5.26,12.3A7.14,7.14,0,1,0,10.192,0m0,13.048a5.9,5.9,0,1,1,5.9-5.9,5.912,5.912,0,0,1-5.9,5.9" transform="translate(0 0.001)" fill="#4c303f"/>
                </g>
            </svg>
        `);
    });
});
    